import React, { useState, useMemo } from "react";
import {
  Clock,
  MapPin,
  User,
  Sparkles,
  Sun,
  Moon,
  Calendar,
} from "lucide-react";

const days = [
  { id: 1, label: "Día 1", date: "3 de septiembre", subtitle: "Inauguración y conferencias" },
  { id: 2, label: "Día 2", date: "4 de septiembre", subtitle: "Talleres y cierre" },
];

const rawAgenda = {
  1: [
    {
      id: "d1-1",
      time: "08:30 - 18:00",
      event: "Zonas interactivas",
      type: "Experiencia",
      isFullDay: true,
      description:
        "Espacios interactivos y tecnológicos abiertos durante toda la jornada.",
    },
    {
      id: "d1-2",
      time: "08:30 - 18:00",
      event: "Summer Camp de Emprendimiento e Innovación UTPL",
      type: "Innovación",
      isFullDay: true,
      description:
        "Talleres continuos y mentorías de proyectos universitarios.",
    },
    {
      id: "d1-3",
      time: "09:00 - 09:30",
      event: "Acto inaugural Edificio Centro de Convenciones",
      type: "Acto inaugural",
    },
    {
      id: "d1-4",
      time: "09:30 - 10:30",
      type: "Acto inaugural",
      speaker: "Ricardo Dueñas - CEO de Grupo Ekos",
      event:
        "La Universidad que transforma del conocimiento al talento, del talento a la empresa y de la empresa al desarrollo",
    },
    {
      id: "d1-5",
      time: "10:30 - 10:45",
      type: "Acto inaugural",
      event: "Intervención Ph. D. Santiago Acosta Aide, Rector UTPL",
    },
    {
      id: "d1-6",
      time: "10:45 - 12:00",
      type: "Acto inaugural",
      event: "Recorrido por las instalaciones del Edificio Centro de Convenciones",
    },
    {
      id: "d1-7",
      time: "12:00 - 15:00",
      event: "Receso",
    },
    {
      id: "d1-8",
      time: "14:30 - 15:00",
      event: "Registro",
      type: "Acceso",
    },
    {
      id: "d1-9",
      time: "15:00 - 15:15",
      type: "Intervención Inaugural",
      event: "Ph. D. Cristina Díaz de la Cruz, Vicerrectora Académica",
    },
    {
      id: "d1-10",
      time: "15:15 - 16:00",
      type: "Conferencia",
      event: "Conferencia magistral: El futuro de la educación",
      speaker:
        "Ph. D. Albert Sangrà Morer, Catedrático Universidad Oberta de Catalunya",
      moderator: "Dr. Artieres Romeiro",
    },
    {
      id: "d1-11",
      time: "16:00 - 18:00",
      type: "Innovación",
      event: "Innova Docentes Interfacultades - Interuniversidades",
    },
    {
      id: "d1-12",
      time: "20:00 - 21:00",
      type: "Cultural",
      event:
        'Obra de teatro: Viajeros en el tiempo "Historia de los 50 años de la MAD UTPL"',
      place: "Teatro Simón Bolívar - Rocafuerte y Olmedo",
    },
  ],

  2: [
    {
      id: "d2-1",
      time: "08:30 - 09:00",
      event: "Registro",
      type: "Acceso",
    },
    {
      id: "d2-2",
      time: "08:30 - 18:00",
      event: "Zonas interactivas",
      type: "Experiencia",
      isFullDay: true,
      description:
        "Exposición continua de proyectos interactivos y tecnológicos.",
    },
    {
      id: "d2-3",
      time: "08:30 - 18:00",
      event: "Summer Camp de Emprendimiento e Innovación UTPL",
      type: "Innovación",
      isFullDay: true,
      description: "Mentorías y laboratorios abiertos para emprendedores.",
    },
    {
      id: "d2-4",
      time: "08:00 - 09:00",
      event: "Eucaristía de Acción de Gracias",
      type: "Eucaristía",
      place: "Capilla UTPL",
    },
    {
      id: "d2-5",
      time: "09:00 - 10:30",
      event: "Innova Docentes Interfacultades - Interuniversidades",
      type: "Innovación",
    },
    {
      id: "d2-6",
      time: "10:30 - 11:00",
      event: "Coffee break",
      type: "Networking",
    },
    {
      id: "d2-7",
      time: "11:00 - 12:30",
      event: "Innova Docentes Interfacultades - Interuniversidades",
      type: "Innovación",
    },
    {
      id: "d2-8",
      time: "12:30 - 15:00",
      event: "Receso",
    },
    {
      id: "d2-9",
      time: "15:00 - 16:00",
      event:
        'Legado que trasciende: "Historias que inspiran, huellas que perduran"',
      type: "Historias",
    },
    {
      id: "d2-10",
      time: "16:00 - 17:00",
      event: '"Ser +", historias que trascienden fronteras',
      type: "Historias",
    },
    {
      id: "d2-11",
      time: "17:00 - 18:00",
      event: "Debate | 50 años ofertando MAD: transformando vidas y contextos",
      type: "Debate",
    },
    {
      id: "d2-12",
      time: "18:00 - 18:30",
      event: "Premiación y cierre",
      type: "Cierre",
    },
    {
      id: "d2-13",
      time: "18:30 - 21:00",
      event: "Noche cultural: UTPL Fest",
      type: "Cultural",
    },
  ],
};

const typeStyles = {
  Conferencia: "bg-blue-50 text-[#004270] border-blue-200 font-semibold",
  Inauguración: "bg-amber-50 text-amber-800 border-amber-200 font-semibold",
  Acceso: "bg-slate-100 text-slate-700 border-slate-200",
  Intervención: "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Intervención Inaugural":
    "bg-indigo-50 text-indigo-700 border-indigo-200 font-semibold",
  Experiencia: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Networking: "bg-sky-50 text-sky-700 border-sky-200",
  Innovación: "bg-purple-50 text-purple-700 border-purple-200",
  Cultural: "bg-rose-50 text-rose-700 border-rose-200 font-semibold",
  Eucaristía: "bg-amber-50 text-amber-700 border-amber-200",
  Historias: "bg-teal-50 text-teal-700 border-teal-200",
  Debate: "bg-orange-50 text-orange-700 border-orange-200",
  Cierre: "bg-[#febe10]/20 text-[#004270] border-[#febe10] font-bold",
};

const getTimePeriod = (timeStr) => {
  const startHour = parseInt(timeStr.split(":")[0], 10);
  if (isNaN(startHour)) return "Mañana";
  if (startHour < 12) return "Mañana";
  if (startHour < 18) return "Tarde";
  return "Noche";
};

export default function AgendaUTPL() {
  const [activeDay, setActiveDay] = useState(1);

  const currentEvents = rawAgenda[activeDay] || [];

  const fullDayEvents = useMemo(() => {
    return currentEvents.filter((e) => e.isFullDay);
  }, [currentEvents]);

  const scheduledEvents = useMemo(() => {
    return currentEvents.filter((e) => !e.isFullDay);
  }, [currentEvents]);

  const groupedScheduledEvents = useMemo(() => {
    const groups = { Mañana: [], Tarde: [], Noche: [] };
    scheduledEvents.forEach((event) => {
      const period = getTimePeriod(event.time);
      groups[period].push(event);
    });
    return groups;
  }, [scheduledEvents]);

  return (
    <section id="agenda" className="py-10 px-4 sm:px-6 max-w-5xl mx-auto">
      <div className="text-center max-w-2xl mx-auto mb-8">
        <h2>Agenda del Evento</h2>
      </div>

      <div className="flex justify-center mb-10">
        <div className="inline-flex p-1.5 bg-slate-200/80 backdrop-blur-md rounded-2xl shadow-inner border border-slate-300/60 max-w-full overflow-x-auto">
          {days.map((day) => {
            const isActive = activeDay === day.id;
            return (
              <button
                key={day.id}
                onClick={() => setActiveDay(day.id)}
                className={`relative px-6 py-3 rounded-xl font-bold text-sm transition-all duration-200 flex items-center gap-3 whitespace-nowrap ${
                  isActive
                    ? "bg-[#004270] text-white shadow-lg shadow-[#004270]/20 scale-[1.02]"
                    : "text-slate-600 hover:text-[#004270] hover:bg-white/50"
                }`}
              >
                <div
                  className={`p-2 rounded-lg ${isActive ? "bg-[#febe10] text-[#004270]" : "bg-slate-200 text-slate-600"}`}
                >
                  <Calendar className="w-5 h-5" />
                </div>
                <div className="text-left">
                  <div className="font-extrabold text-sm">
                    {day.label}: {day.date}
                  </div>
                  {day.subtitle && (
                    <div
                      className={`text-xs ${isActive ? "text-slate-200" : "text-slate-500"} font-normal`}
                    >
                      {day.subtitle}
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {fullDayEvents.length > 0 && (
        <div className="mb-10">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-500"></span>
              </span>
              <h3 className="text-base font-bold text-[#004270]">
                Actividades continuas (Todo el día)
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
            {fullDayEvents.map((item) => (
              <div
                key={item.id}
                className="group bg-gradient-to-br from-white to-slate-50 p-5 rounded-2xl border-2 border-[#febe10]/40 shadow-xs hover:shadow-md hover:border-[#febe10] transition-all flex flex-col justify-between"
              >
                <div>
                  <div className="flex items-center justify-between mb-3">
                    <span className="inline-flex items-center gap-1.5 text-xs font-bold px-2.5 py-1 rounded-full bg-[#004270] text-white">
                      <Clock className="w-3.5 h-3.5 text-[#febe10]" />
                      {item.time}
                    </span>
                  </div>

                  <h4 className="font-bold text-base text-slate-900 group-hover:text-[#004270] transition-colors mb-2">
                    {item.event}
                  </h4>

                  {item.description && (
                    <p className="text-xs text-slate-600 line-clamp-2 mb-3">
                      {item.description}
                    </p>
                  )}
                </div>

                <div className="pt-3 border-t border-slate-100 flex items-center justify-between text-xs">
                  <span
                    className={`px-2.5 py-0.5 rounded-md border ${typeStyles[item.type] || "bg-slate-100 text-slate-700"}`}
                  >
                    {item.type}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="space-y-8">
        <div className="flex items-center justify-between border-b border-slate-200 pb-3">
          <h3 className="text-lg font-bold text-[#004270] flex items-center gap-2">
            <Clock className="w-5 h-5 text-[#febe10]" />
            Cronograma
          </h3>
        </div>

        {Object.entries(groupedScheduledEvents).map(([period, events]) => {
          if (events.length === 0) return null;

          const PeriodIcon =
            period === "Mañana" ? Sun : period === "Tarde" ? Sparkles : Moon;
          const periodBadgeBg =
            period === "Mañana"
              ? "bg-amber-100 text-amber-900 border-amber-300"
              : period === "Tarde"
                ? "bg-sky-100 text-sky-900 border-sky-300"
                : "bg-indigo-100 text-indigo-900 border-indigo-300";

          return (
            <div key={period} className="space-y-4">
              <div className="sticky top-4 z-10 flex items-center gap-3">
                <span
                  className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold border shadow-xs backdrop-blur-md ${periodBadgeBg}`}
                >
                  <PeriodIcon className="w-3.5 h-3.5" />
                  {period}
                </span>
                <div className="h-px bg-slate-200 flex-1"></div>
              </div>

              <div className="relative pl-3 sm:pl-6 space-y-4 border-l-2 border-slate-200 ml-3 sm:ml-4">
                {events.map((item) => (
                  <div
                    key={item.id}
                    className="relative group bg-white rounded-2xl p-5 sm:p-6 border border-slate-200/80 shadow-xs hover:shadow-md hover:border-[#febe10] transition-all flex flex-col md:flex-row md:items-start gap-4 sm:gap-6"
                  >
                    <div className="absolute -left-[19px] sm:-left-[31px] top-7 w-3.5 h-3.5 rounded-full bg-white border-4 border-[#004270] group-hover:border-[#febe10] group-hover:scale-125 transition-all"></div>

                    <div className="md:w-44 flex-shrink-0 flex md:flex-col justify-between md:justify-start items-start gap-1">
                      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-xl bg-slate-100 text-[#004270] font-black text-sm group-hover:bg-[#febe10] group-hover:text-[#004270] transition-colors">
                        <Clock className="w-4 h-4 flex-shrink-0" />
                        <span>{item.time}</span>
                      </div>

                      <div className="mt-2 hidden md:block">
                        <span
                          className={`inline-block px-2.5 py-1 rounded-md text-xs border ${typeStyles[item.type] || "bg-slate-100 text-slate-600 border-slate-200"}`}
                        >
                          {item.type || "General"}
                        </span>
                      </div>
                    </div>

                    <div className="flex-1 space-y-2">
                      <div className="md:hidden mb-1">
                        <span
                          className={`inline-block px-2.5 py-0.5 rounded-md text-xs border ${typeStyles[item.type] || "bg-slate-100 text-slate-600"}`}
                        >
                          {item.type || "General"}
                        </span>
                      </div>

                      <h4 className="text-base sm:text-lg font-extrabold text-slate-900 group-hover:text-[#004270] transition-colors">
                        {item.event}
                      </h4>

                      {item.speaker && (
                        <div className="flex items-start gap-2 text-xs sm:text-sm text-slate-700 bg-slate-50 p-2.5 rounded-xl border border-slate-100">
                          <User className="w-4 h-4 text-[#004270] mt-0.5 flex-shrink-0" />
                          <div>
                            <span className="font-bold text-[#004270]">
                              Ponente:
                            </span>{" "}
                            <span className="font-medium text-slate-800">
                              {item.speaker}
                            </span>
                          </div>
                        </div>
                      )}

                      {item.moderator && (
                        <div className="text-xs text-slate-600 pl-6 italic">
                          <span className="font-semibold text-slate-700">
                            Moderador:
                          </span>{" "}
                          {item.moderator}
                        </div>
                      )}

                      {item.place && (
                        <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-500 pt-1">
                          <MapPin className="w-4 h-4 text-[#febe10]" />
                          <span>{item.place}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}